import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { SavedReport, ReportType, ExamType } from '../../types/reports';

interface ReportsState {
  reports: SavedReport[];
  currentReport: SavedReport | null;
  isLoading: boolean;
  error: string | null;
  draftData: Record<string, any>; // Form draft data keyed by form ID
  filters: {
    patient_id?: string;
    report_type?: ReportType;
    exam_type?: ExamType;
    date_from?: string;
    date_to?: string;
  };
}

const initialState: ReportsState = {
  reports: [],
  currentReport: null,
  isLoading: false,
  error: null,
  draftData: {},
  filters: {},
};

const reportsSlice = createSlice({
  name: 'reports',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    setCurrentReport: (state, action: PayloadAction<SavedReport | null>) => {
      state.currentReport = action.payload;
    },
    setFilters: (state, action: PayloadAction<Partial<ReportsState['filters']>>) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    addReport: (state, action: PayloadAction<SavedReport>) => {
      state.reports.unshift(action.payload);
    },
    updateReport: (state, action: PayloadAction<SavedReport>) => {
      const index = state.reports.findIndex(r => r.id === action.payload.id);
      if (index !== -1) {
        state.reports[index] = action.payload;
      }
    },
    removeReport: (state, action: PayloadAction<string>) => {
      state.reports = state.reports.filter(r => r.id !== action.payload);
    },
  },
});

export const {
  clearError,
  setCurrentReport,
  setFilters,
  addReport,
  updateReport,
  removeReport,
} = reportsSlice.actions;

export default reportsSlice.reducer;
